import { PaginatedData, PaginationParams } from 'models/Pagination';
import { User } from 'models/User';
import httpClient from '../../httpClient';

function getAdmins(params?: PaginationParams) {
  return httpClient.get<PaginatedData<User>>('users/admins', {
    params,
  });
}

function addAdmin(admin: Partial<User>) {
  return httpClient.post(`users/admin`, admin);
}

export default {
  getAdmins,
  addAdmin,
};
